import React from "react"
import { Link } from "gatsby"
import Logo from "../../assets/kaden-logo.inline.svg"

class Navbar extends React.Component {
  render() {
    const menu = this.props.data
    const mobileMenu = this.props.mobile
    // make the "contact us" button appear inactive when on the "request an installer" page
    const isRequestInstaller = () => {
      return location.pathname == "/request-an-installer/"
        ? {
            className:
              "uk-button uk-button-primary uk-border-pill uk-button-outline",
          }
        : {}
    }

    const navbar = (
      <div
        className="menu-wrap uk-background-default"
        uk-sticky="show-on-up: true; animation: uk-animation-slide-top;"
      >
        <div className="navbar-outer uk-padding-xsmall">
          <div className="uk-container uk-flex uk-flex-middle uk-flex-between">
            <div className="uk-visible@m">
              <Link to="/" className="logo-link" activeClassName="uk-active">
                <Logo className="logo logo--primary" />
              </Link>
            </div>
            <div className="uk-flex uk-flex-middle uk-visible@m">
              {menu.map((item) => (
                <div key={item.label}>
                  {item.children ? (
                    <button
                      className="uk-button uk-button-link uk-margin-left uk-margin-right"
                      uk-toggle={
                        "target: #" +
                        item.id +
                        "; animation: uk-animation-fade;"
                      }
                    >
                      {item.label} <span uk-icon="triangle-down"></span>
                    </button>
                  ) : (
                    <Link
                      to={item.path}
                      className="uk-button uk-button-link uk-margin-left uk-margin-right"
                      activeClassName="uk-active"
                    >
                      {item.label}
                    </Link>
                  )}
                </div>
              ))}
            </div>
            <div className="uk-hidden@m zero-line-height">
              <button
                className="uk-button uk-button-link uk-transform-origin-top-center zero-line-height"
                uk-toggle="target: #mobileNav, .menu-icon; animation: uk-animation-slide-top-small;"
              >
                <span
                  className="menu-icon"
                  uk-icon="icon: table; ratio: 1.1"
                ></span>
                <span
                  className="menu-icon"
                  uk-icon="icon: close; ratio: 1.1"
                  hidden
                ></span>
              </button>
            </div>
            <div>
              {/*<Link
                to="/request-an-installer/"
                className="uk-button uk-button-primary uk-button-outline uk-border-pill uk-margin-small-right uk-visible@m"
                activeClassName="uk-button-active"
              >
                Request an installer
              </Link>*/}
              <Link
                to="/contact-us/"
                className="uk-button uk-button-primary uk-border-pill"
                activeClassName="uk-button-active"
                getProps={isRequestInstaller}
              >
                Contact us
              </Link>
            </div>
          </div>
        </div>
        {menu.map((item) =>
          item.children ? (
            <div key={item.path} className="dropdown-outer" id={item.id} hidden>
              <div className="uk-container">
                <div className="uk-flex uk-grid uk-grid-small uk-padding uk-padding-remove-bottom uk-padding-remove-horizontal dropdown-full">
                  {item.children.map((child) => (
                    <div key={child.path} className="child-nav uk-width-1-6@m">
                      <div className="uk-flex uk-flex-wrap">
                        <div className="uk-margin-small-right">
                          <Link to={child.path}>
                            <img
                              src={child.img}
                              className="uk-border-rounded"
                            />
                          </Link>
                        </div>
                        <div className="sub-menu-list uk-margin-small-top uk-margin-large-bottom uk-width-1-1">
                          <Link
                            to={child.path}
                            className="uk-text-p-large"
                            activeClassName="uk-active"
                          >
                            {child.label}
                          </Link>
                          {child.children ? (
                            <ul className="uk-list uk-margin-small uk-text-small product-children">
                              {child.children.map((childProd) => (
                                <li key={childProd.label}>
                                  <Link
                                    to={childProd.path}
                                    className=""
                                    activeClassName="uk-active"
                                  >
                                    {childProd.label}
                                  </Link>
                                </li>
                              ))}
                            </ul>
                          ) : null}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ) : null
        )}
        <div
          id="mobileNav"
          className="uk-padding-small uk-padding-remove-vertical mobile-nav"
          hidden
        >
          <ul
            className="uk-nav uk-nav-parent-icon uk-margin uk-margin-top"
            uk-nav=""
          >
            {mobileMenu.map((item) => (
              <li
                key={item.path}
                className={item.children ? "uk-parent" : null}
              >
                {item.children ? (
                  <a href={item.path} className="uk-text-p-large">
                    {item.label}
                  </a>
                ) : null}
                {item.children ? (
                  <ul className="uk-nav-sub">
                    {item.children.map((child) => (
                      <li key={child.path}>
                        <Link
                          to={child.path}
                          className="uk-link-muted"
                          activeClassName="uk-active"
                        >
                          {child.label}
                        </Link>
                      </li>
                    ))}
                  </ul>
                ) : (
                  <Link
                    to={item.path}
                    className="uk-text-p-large"
                    activeClassName="uk-active"
                  >
                    {item.label}
                  </Link>
                )}
              </li>
            ))}
          </ul>
        </div>
      </div>
    )

    return navbar
  }
}

export default Navbar
